'use strict';
var toCamelCase;

toCamelCase = function(s) {
  var Word;
  if (!s) {
    throw new Error('String not defined');
  }
  Word = function(w) {
    return w.charAt().toUpperCase() + w.slice(1);
  };
  return s.split(/[-\s_.,&]+/g).map(Word).join('');
};

module.exports = {
  toCamelCase: toCamelCase
};

